import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async syncsCentrosCustos({ commit }) {
      try {
        return await api.get('/sincronizacoes/centros-custos')
      } catch (error) {
        throw error
      }
    },

    async syncsCentrosCustosUsuarios({ commit }) {
      try {
        return await api.get('/sincronizacoes/centros-custos-usuarios')
      } catch (error) {
        throw error
      }
    },

    async syncsNaturezasOrcamentarias({ commit }) {
      try {
        return await api.get('/sincronizacoes/naturezas-orcamentarias')
      } catch (error) {
        throw error
      }
    },

    async syncsCentrosCustosNaturezasOrcamentarias({ commit }) {
      try {
        return await api.get(
          '/sincronizacoes/centros-custos-naturezas-orcamentarias',
        )
      } catch (error) {
        throw error
      }
    },

    async syncsMetas({ commit }) {
      try {
        return await api.get('/sincronizacoes/metas')
      } catch (error) {
        throw error
      }
    },

    async syncsRelatorioOrcamentario({ commit }) {
      try {
        return await api.get('/sincronizacoes/relatorio-orcamentario')
      } catch (error) {
        throw error
      }
    },

    async syncsRegistrosProposta({ commit }, orcamentoId) {
      try {
        return await api.get(
          `/sincronizacoes/registros-proposta?orcamentoId=${orcamentoId}`,
        )
      } catch (error) {
        throw error
      }
    },

    async syncsValoresOrcadosBloqueados({ commit }) {
      try {
        return await api.get('/sincronizacoes/valores-orcados-bloqueados')
      } catch (error) {
        throw error
      }
    },

    async syncsRegistrosRealizado({ commit }) {
      try {
        return await api.get('/sincronizacoes/registros-realizado')
      } catch (error) {
        throw error
      }
    },

    async syncsValoresRealizadosParaReformulado({ commit }) {
      try {
        await api.get('/sincronizacoes/registros-realizado')

        return await api.get(
          '/sincronizacoes/valores-realizados-para-reformulado',
        )
      } catch (error) {
        throw error
      }
    },

    async syncsRelatorioImportacaoSistego({ commit }) {
      try {
        return await api.get('/sincronizacoes/relatorio-importacao-sistego')
      } catch (error) {
        throw error
      }
    },

    async syncsAnaliseOrcamentariaValoresPropostos({ commit }) {
      try {
        return await api.get(
          '/sincronizacoes/analise-orcamentaria-valores-propostos',
        )
      } catch (error) {
        throw error
      }
    },

    async syncsAnaliseOrcamentariaValoresRealizados({ commit }) {
      try {
        return await api.get(
          '/sincronizacoes/analise-orcamentaria-valores-realizados',
        )
      } catch (error) {
        throw error
      }
    },

    async syncsCentrosCustosGestores({ commit }) {
      try {
        return await api.get('/sincronizacoes/centros-custos-gestores')
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
